/**
 * Stands in for a native page whose Start version isn't written yet. It exists only while the
 * port is in progress: the Start runtime ships once no route or block renders it.
 */
export function NativePending({ name }: { name: string }) {
  return (
    <section className="section" data-native-pending={name}>
      <div className="container">
        <p className="eyebrow">In progress</p>
        <h1>{name}</h1>
        <p className="prose">This native page is still being moved to the new site runtime.</p>
      </div>
    </section>
  );
}
